<template>
  <div v-if="isVisible" class="cookie-consent" role="dialog" aria-live="polite" aria-label="Aviso de cookies">
    <div class="cookie-consent__panel">
      <p class="cookie-consent__text">
        Usamos cookies para el funcionamiento de la tienda, al continuar navegando aceptas el uso de cookies.
      </p>

      <div class="cookie-consent__actions">
        <router-link class="cookie-consent__link" :to="{ name: 'PrivacyPolicy' }">
          Ver detalles
        </router-link>
        <button class="cookie-consent__button" type="button" @click="acceptAll">
          Entendido
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const STORAGE_KEY = 'godea_cookie_consent_v1'

const isVisible = ref(false)

function persistConsent(preferences) {
  const payload = {
    acceptedAt: new Date().toISOString(),
    preferences: {
      necessary: true,
      analytics: Boolean(preferences.analytics),
      personalization: Boolean(preferences.personalization),
      marketing: Boolean(preferences.marketing),
    },
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload))
  window.dispatchEvent(new CustomEvent('cookie-consent-updated', { detail: payload }))
  isVisible.value = false
}

function acceptAll() {
  persistConsent({
    analytics: true,
    personalization: true,
    marketing: true,
  })
}

onMounted(() => {
  isVisible.value = !localStorage.getItem(STORAGE_KEY)
})
</script>

<style scoped>
.cookie-consent {
  position: fixed;
  left: 12px;
  bottom: 12px;
  z-index: 1200;
  width: min(300px, calc(100vw - 24px));
  pointer-events: none;
}

.cookie-consent__panel {
  display: grid;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(17, 17, 17, 0.55);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(18px) saturate(1.4);
  -webkit-backdrop-filter: blur(18px) saturate(1.4);
  pointer-events: auto;
}

.cookie-consent__text {
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 11px;
  font-weight: 300;
  line-height: 1.4;
}

.cookie-consent__actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.cookie-consent__button {
  height: 26px;
  padding: 0 8px;
  border: 1px solid #ffffff;
  border-radius: 0;
  background: #ffffff;
  color: #111111;
  font-family: inherit;
  font-size: 9px;
  font-weight: 400;
  line-height: 1;
  cursor: pointer;
}

.cookie-consent__link {
  color: rgba(255, 255, 255, 0.7);
  font-size: 9px;
  font-weight: 400;
  text-decoration: underline;
  text-underline-offset: 3px;
}

@media (max-width: 480px) {
  .cookie-consent {
    left: 10px;
    bottom: 10px;
    width: calc(100vw - 20px);
  }
}
</style>
